<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)">
                <div class="notification is-info" v-if="salvandoDados">
                    <button class="delete"></button>
                    {{$t('ARQUITETOCADASTRO.SALVANDOCADASTRO')}}
                </div>

                <div class="tile is-ancestor">
                    <div class="tile is-parent is-vertical is-9">
                        <article class="tile is-child box">
                            <div class="columns">
                                <div class="column is-two-thirds">
                                    <ValidationProvider rules="required" name="nome" v-slot="{ errors, valid }">
                                        <b-field :label="$t('SISTEMA.NOME')"
                                                 :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                                 :message="errors">
                                            <b-input type="text" maxlength="150" v-model="model.nome"></b-input>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                                <div class="column is-one-third">
                                    <ValidationProvider rules="required" name="tipo" v-slot="{ errors, valid }">                                
                                        <b-field :label="$t('SISTEMA.TIPO')"
                                                 :message="errors"
                                                 :type="{ 'is-danger': errors[0], 'is-success': valid }">
                                            <b-select expanded v-model="model.tipo">                                            
                                                <template v-for="(item, index) in arquitetosTipos">
                                                    <option v-bind:key="index" :value="item.codigo">
                                                        {{item.descricao}}
                                                    </option>
                                                </template>
                                            </b-select>
                                        </b-field>                                
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column is-one-third">
                                    <b-field :label="$t('ARQUITETOCADASTRO.DATANASCIMENTO')">
                                        <b-datepicker
                                            :placeholder="$t('ARQUITETOCADASTRO.DATANASCIMENTO')"
                                            icon="calendar-today"
                                            v-model="model.dataNascimento"
                                        >
                                        </b-datepicker>
                                    </b-field>
                                </div>
                                <div class="column is-one-third">
                                    <b-field :label="$t('ARQUITETOCADASTRO.TELEFONE')">
                                        <b-input v-model="model.telefone"
                                            v-mask="['(##) ####-####', '(##) #####-####']"
                                            :placeholder="$t('ARQUITETOCADASTRO.TELEFONE')"
                                            type="tel">
                                        </b-input>
                                    </b-field>
                                </div>
                                <div class="column is-one-third">
                                    <b-field :label="$t('ARQUITETOCADASTRO.INSTAGRAM')">
                                        <b-input v-model="model.instagram"
                                            :placeholder="$t('ARQUITETOCADASTRO.INSTAGRAM')"
                                            type="text">
                                        </b-input>
                                    </b-field>
                                </div>
                            </div>
                            <div v-show="!isVendedor()" class="columns">
                                <div class="column is-one-third">
                                    <b-field :label="$t('ARQUITETOCADASTRO.VENDEDORRESPONSAVEL')">
                                        <b-select v-model="model.funcionarioComercial.id" :placeholder="$t('ARQUITETOCADASTRO.VENDEDORRESPONSAVEL')" expanded>
                                            <option :value="null"></option>
                                            <template v-for="(item, index) in listaVendedoresUnidade">
                                                <option v-bind:key="index" :value="item.id">
                                                    {{item.nome}}
                                                </option>
                                            </template>
                                        </b-select>
                                    </b-field>
                                </div>
                            </div>
                        </article>
                    </div>     
                    <div class="tile is-parent">
                        <article class="tile is-child">
                            <article class="panel">
                                <div class="panel-heading has-text-centered">
                                    {{$t('ATENDIMENTO.ULTIMOSAGENDAMENTOS')}}
                                </div>
                                <div v-for="(agendamento, index) in agendamentos.slice(0,5)" v-bind:key="index">
                                    <a v-if="(agendamento.agendamentoAutomatico==false)" class="panel-block">
                                        <span class="panel-icon block">                                            
                                            <b-icon :style="tipoAgendamentoStyle(agendamento)"  size="is-small" icon="square-rounded"></b-icon>                                            
                                        </span>                                        
                                        <p> {{agendamento.tipoAgendamentoNome}} - {{ agendamento.dataHora }}</p>
                                    </a>
                                </div>    
                                <div>
                                    <a  @click="verTodosAgendamentos()" class="panel-block">
                                            <span class="panel-icon block">                                            
                                                <b-icon   size="is-small" icon="view-list"></b-icon>                                            
                                            </span>                                        
                                            <p> Ver todos</p>
                                    </a> 
                                </div>                                                                                                                           
                                <div class="panel-block">                                    
                                    <b-button expanded class="button is-info" @click="abrirCalendario()" > {{$t('ATENDIMENTO.ABRIRCALENDARIO')}} </b-button>                                            
                                </div>
                            </article>

                                                   
                        </article>
                    </div>                                                   
                </div>
                <nav class="level">
                    <div class="level-item">
                        <p class="buttons">
                            <b-button type="is-success"
                                      v-show="isInRole('arquiteto-alterar')"
                                      :loading="salvandoDados"
                                      native-type="button" @click="salvar()"
                                      icon-left="check-circle">
                                {{$t('SISTEMA.SALVAR')}}
                            </b-button>
                            <b-button type="is-danger"
                                      native-type="button"
                                      icon-left="close-circle"
                                      @click="$router.back();">
                                {{$t('SISTEMA.CANCELAR')}}
                            </b-button>
                        </p>
                    </div>
                </nav>

                <div class="tile is-ancestor mt-1">
                    <div class="tile is-parent is-vertical">
                        <article class="tile is-child box">
                            <div class="columns is-flex is-align-items-center">
                                <div class="column is-10">      
                                    <textarea class="textarea" v-model="observacoes" rows="1"></textarea>
                                </div>

                                <div class="column">
                                    <b-button type="is-success"
                                                v-show="isInRole('arquiteto-alterar')"
                                                :loading="salvandoDados"
                                                native-type="button" @click="incluirObservacao()"
                                                icon-left="check-circle">
                                        {{$t('ARQUITETOCADASTRO.INCLUIR')}}
                                    </b-button>
                                </div>
                            </div>
    
                            <b-collapse class="panel m-0" animation="slide" :open="false" >
                                <template #trigger="props">
                                    <div
                                        class="card-header" role="button" :aria-expanded="props.open">
                                        <p class="card-header-title">
                                            {{$t('ARQUITETOCADASTRO.TODASOBSERVACOES')}}
                                        </p>
                                        <a class="card-header-icon">
                                            <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"> </b-icon>
                                        </a>
                                    </div>
                                </template>
    
                                <div v-if="isLoading">
                                    <b-loading active></b-loading>
                                </div>
                                <div v-else class="b-table">
                                    <div class="table-wrapper has-mobile-cards">
                                        <table class="table is-fullwidth">
                                            <tr v-for="(item, index) in historicoObservacoes" :key="index">
                                                <td>
                                                    <h4>
                                                        {{ item.observacao }}
                                                    </h4>
                                                </td>
                                                <td>
                                                    <span><b>{{ item.usuarioNome }}</b> ({{ item.usuarioId}})</span>
                                                </td>
                                                <td>
                                                    <span>{{ item.dataHora | moment('DD/MM/YYYY HH:mm') }}</span>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </b-collapse>
                        </article>
                    </div>
                </div>
            </form>
        </ValidationObserver>
    </section>
</template>

<script>
    import { mapGetters,mapState } from 'vuex'
    import titlebar from '@/components/titlebar.vue'
    import modalListarAgendamentosCliente from '@/components/atendimento/modalListarAgendamentosCliente.vue' 
    import moment from 'moment';    

    export default {
        components: {
            titlebar
        },
        data() {
            return {
                model: {
                    id: null,
                    nome: null,
                    tipo: null,
                    dataNascimento: null,
                    telefone: null,
                    instagram: null,
                    funcionarioComercial: {
                        id: 0,
                    },
                },
                arquitetosTipos: [],                                
                listaVendedoresUnidade: [],
                observacoes: null,
                historicoObservacoes: [],
                isLoading: false,
                salvandoDados: false,
                agendamentos:[],
            }
        },
        created() {
            this.carregarVendedoresUnidade()

            if(this.$route.params.id){
                this.$http.get('/api/manutencao/arquiteto?id=' + this.$route.params.id)
                    .then(res => {
                        this.model = res.data;                        
                        if (this.model.id) {
                            this.listarObservacoes();
                        }
                        if (this.model.dataNascimento) {
                            this.model.dataNascimento = new Date(this.model.dataNascimento);
                        }
                        if (!this.model.funcionarioComercial) {
                            this.model.funcionarioComercial = {
                                id: 0
                            };
                        }
                    }).finally(() => {                                                            
                        this.loadAgendamentos();                                
                    });   
            }

            this.$http.get('/api/search/ArquitetoTipo')
            .then(res => {
                if (res.data != null) {
                    this.arquitetosTipos = res.data                    
                }
            });             
        },
        computed: {
            titleStack() {
                return [
                    this.$t('SISTEMA.MANUTENCAO'),
                    this.$t('ARQUITETOCADASTRO.ARQUITETO'),
                    this.model.id ?? this.$t('SISTEMA.NOVO')
                ]
            },
            ...mapState([                                
                'unidadeId','usuario',                
            ]),                
            ...mapGetters([
                'isInRole'
            ])
        },
        methods: {

            loadAgendamentos() {                
                this.$http.get('/api/agenda/AgendamentosArquiteto?id=' + this.model.id)
                        .then(res => res.data)
                        .then(data => {
                            if (data != null && data.length>0 ) {
                              
                                
                                    this.agendamentos = data?.map( (d) => {
                                        return {
                                            id: d.id,                                                                                                                        
                                            tipoAgendamentoId: d.tipoAgendamentoId,
                                            tipoAgendamentoCor: d.tipoAgendamentoCor,
                                            tipoAgendamentoNome : d.tipoAgendamentoNome,
                                            agendamentoAutomatico: d.agendamentoAutomatico,
                                            dataHora: moment(d.dataHora).format('DD/MM/YYYY HH:mm:ss'),
                                            funcionarioResponsavelNome: d.funcionarioResponsavelNome,
                                            observacao: d.observacao
                                        }
                                    });  
                               

                            }
                        });
            },                    
            verTodosAgendamentos(){                
                this.$buefy.modal.open({
                    parent: this,
                    component: modalListarAgendamentosCliente,
                    props: {
                        agendamentos: this.agendamentos                                                                                 
                    },  
                                                                            
                    hasModalCard: true,
                    trapFocus: true,
                    fullScreen: true
                })                   
            },            
            abrirCalendario(){

                    const guia = {
                        tipoAgenda : 4,
                        clienteNome: 'ARQUITETO '+ this.model.nome,
                        id : this.model.id
                    }
                    const filtrarTiposAgenda = null;
                    const filtrarTodos = true;
                    const voltarTela =  this.voltarTela ?? 'arquitetos';
                    this.$router.push({ name: 'agenda',query:{tipo: 1}, params: { guia: guia,filtrarTiposAgenda:filtrarTiposAgenda, filtrarTodos: filtrarTodos,voltarTela:voltarTela}  });                   
                
            },            
            tipoAgendamentoStyle(evento) {
                return 'color: #' + evento.tipoAgendamentoCor + '!important'
            },                
            isVendedor(){                
                return this.usuario.nivel == 'Vendedor' || this.usuario.nivel.includes('Vendedor');
            },              
            onSubmit() {
                this.salvandoDados = true;
                if(this.model.id == null){
                    this.model.id = 0
                }
                
                this.model.UnidadeDeCadastro = { id : this.unidadeId};
                if (this.model.funcionarioComercial.id ==null) {
                    this.model.funcionarioComercial = {
                        id: 0
                    };
                }                
                
                this.$http.post(`/api/manutencao/arquiteto`, this.model)
                    .then(() => {
                        this.salvandoDados = false;
                        this.$router.back()
                    })
                    .catch((error) => {
                        this.salvandoDados = false;
                        throw error
                    });
            },
            salvar() {
                this.onSubmit();
            },
            incluirObservacao() {
                this.salvandoDados = true;

                const arquitetoObservacao = {
                    arquitetoId: this.model.id,
                    observacao : this.observacoes
                }

                try {
                    this.$http.post('/api/manutencao/ArquitetoObservacao', arquitetoObservacao)
                        .then(res => {
                            this.salvandoDados=false;
                            return true;
                        }).finally(() => {
                            this.salvandoDados=false;
                            this.observacoes = null;
                            this.listarObservacoes();

                            this.$buefy.toast.open({
                                duration: 5000,
                                message: this.$t('GUIAATENDIMENTO.MENSAGEMOBSERVACAOSALVA'),
                                type: 'is-success'
                            });
                        }); 
                } catch (e) {
                    this.salvandoDados=false;
                    console.error(e);
                }
            },
            listarObservacoes() {
                this.isLoading = true

                this.$http.get(`/api/manutencao/ArquitetoObservacoes?arquitetoId=${this.model.id}`)
                    .then(({ data }) => {
                        this.historicoObservacoes = data
                    }).catch(e => {
                        console.error(e)
                    }).finally(() => {
                        this.isLoading = false
                    })
            },
            carregarVendedoresUnidade(){
                this.$http.get(`/api/search/FuncionarioComercial?unidadeId=${this.unidadeId}`)
                .then(res => res.data)
                .then(data => {
                    if (data != null) {
                        this.listaVendedoresUnidade = data;
                    }
                });
            },
        }
    }
</script>